export default class Slider {
  constructor(item, lang) {
    this._setId(item);
    this._setTitle(item, lang);
    this._setDescription(item, lang);
    this._setUrl(item, lang);
    this._setImage(item);
  }

  /**
   * set id
   * @param {id} param0
   */
  _setId({ id }) {
    this.id = id;
  }

  /**
   * set title
   * @param {slider} item
   * @param {language} lang
   */
  _setTitle(item, lang) {
    let key = "title_" + lang;
    this.title = item[key];
  }

  /**
   * set description
   * @param {slider} item
   * @param {language} lang
   */
  _setDescription(item, lang) {
    let key = "description_" + lang;
    this.description = item[key];
  }

  /**
   * set url
   * @param {url} param0
   */
  _setUrl(item, lang) {
    let key = "urL_" + lang;
    this.url = item[key];
  }

  /**
   * set image
   * @param {image} param0
   */
  _setImage({ photoUrl }) {
    this.image = photoUrl;
  }
}
